var _defs, _circle, _circle2, _g, _ellipse, _ellipse2, _path, _ellipse3, _path2, _path3, _path4, _ellipse4, _ellipse5, _g2, _path5, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 196,
    viewBox: "0 0 320 270",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "kdlpHeroBg",
    cx: "50%",
    cy: "42%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDF7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DCEEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kdlpHeroBeam",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D4A24C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D4A24C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kdlpHeroPhone",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2A5A45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A3A2B"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 118,
    fill: "url(#kdlpHeroBg)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 118,
    fill: "none",
    stroke: "#CFE6D6",
    strokeWidth: 1.5,
    strokeDasharray: "2 9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9DBCAA",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 70c-4-5 4-8 0-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 66c-4-5 4-8 0-13"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 214,
    rx: 120,
    ry: 26,
    fill: "#E7D5B4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 210,
    rx: 120,
    ry: 26,
    fill: "#F0E2C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 210a120 26 0 0 0 240 0v6a120 26 0 0 1-240 0Z",
    fill: "#E3CDA0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 196,
    rx: 42,
    ry: 11,
    fill: "#D8C49E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 168h56l-5 24a9 9 0 0 1-9 7H88a9 9 0 0 1-9-7Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 168h56l-1.2 6H75.2Z",
    fill: "#E6F4EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130 172c12-3 16 14 3 17l-1-7c5-1 4-7-1-6Z",
    fill: "#FFFFFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 170,
    rx: 26,
    ry: 6,
    fill: "#6B4F3A"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 169,
    rx: 20,
    ry: 4.4,
    fill: "#8A6A4F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7 168 196)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 176,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1A3A2B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 182,
    width: 10,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 185,
    width: 4,
    height: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 182,
    width: 10,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 185,
    width: 4,
    height: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 200,
    width: 10,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 203,
    width: 4,
    height: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 198,
    width: 3.4,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 198,
    width: 3.4,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 198,
    width: 3.4,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 203,
    width: 3.4,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 203,
    width: 3.4,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 208,
    width: 3.4,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 208,
    width: 3.4,
    height: 3.4
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214 92 170 188l28 0 40-96Z",
    fill: "url(#kdlpHeroBeam)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(13 214 110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 48,
    width: 72,
    height: 132,
    rx: 16,
    fill: "url(#kdlpHeroPhone)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 54,
    width: 60,
    height: 120,
    rx: 11,
    fill: "#F7FBF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 58,
    width: 24,
    height: 5,
    rx: 2.5,
    fill: "#1A3A2B",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#D4A24C",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 92v-6a4 4 0 0 1 4-4h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 92v-6a4 4 0 0 0-4-4h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 140v6a4 4 0 0 0 4 4h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 140v6a4 4 0 0 1-4 4h-6"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2A5A45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 98,
    width: 9,
    height: 9,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.6,
    y: 100.6,
    width: 3.8,
    height: 3.8,
    fill: "#F7FBF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 98,
    width: 9,
    height: 9,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.6,
    y: 100.6,
    width: 3.8,
    height: 3.8,
    fill: "#F7FBF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 117,
    width: 9,
    height: 9,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.6,
    y: 119.6,
    width: 3.8,
    height: 3.8,
    fill: "#F7FBF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 116,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 116,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 116,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 121,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 121,
    width: 3,
    height: 3
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 250 188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236 168h26v34l-5-3-4 3-4-3-4 3-5-3Z",
    fill: "#FFFFFF",
    stroke: "#E2E8E0",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C9B083",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241 176h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 183h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 190h10"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#B98F45",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 178v22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 178v8m6-8v8m6-8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 186h12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingHero);
export default __webpack_public_path__ + "static/media/landing-hero.b2c4f3dd.svg";
export { ForwardRef as ReactComponent };